import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';

}



// WEBPACK FOOTER //
// G:/Projekty/swaythegame/src/app/app.component.ts